import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ModalShell from '@/components/modal-shell';
import { Button } from '@/components/ui/button';

interface PublishedWarningModalProps {
  onClose: () => void;
  onProceed: () => void;
}

export default function PublishedWarningModal({ onClose, onProceed }: PublishedWarningModalProps) {
  const { t } = useTranslation();
  return (
    <ModalShell title={t('modals.publishedWarning.title')} onClose={onClose}
      icon={<AlertTriangle aria-hidden='true' className='h-5 w-5 shrink-0 text-ws-text' />}>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col gap-2'>
          <p className='font-medium text-ws-text'>{t('modals.publishedWarning.subtitle')}</p>
          <p className='text-sm text-ws-muted'>{t('modals.publishedWarning.warning')}</p>
          <p className='text-sm text-ws-muted'>{t('modals.publishedWarning.detail')}</p>
        </div>
        <div className='flex items-center justify-between gap-3'>
          <Button variant='secondary' onClick={onClose}>{t('common.cancel')}</Button>
          <Button variant='primary' onClick={onProceed}>{t('modals.publishedWarning.proceed')}</Button>
        </div>
      </div>
    </ModalShell>
  );
}
